/**
 * Creado por Norte70
 *
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 23/10/2020
 */
import * as SessionUtils from './../../../core/session_utils.js'

const processesRequirementsRequestModel = () => {
    return {
        processId: 1,
        invited: SessionUtils.isGuestUser(),
        sessionUser: SessionUtils.getGuestUserToken(),
        userId: null
    }
}

export default processesRequirementsRequestModel;